/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_My_FilesInputs */

const en_common_my_files = /** @type {(inputs: Common_My_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Files`)
};

const es_common_my_files = /** @type {(inputs: Common_My_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis archivos`)
};

/**
* | output |
* | --- |
* | "My Files" |
*
* @param {Common_My_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_my_files = /** @type {((inputs?: Common_My_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_My_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_my_files(inputs)
	return en_common_my_files(inputs)
});